




import { MsgTransports } from "@/store/types";
import { Component, Vue } from "vue-property-decorator";
import Templates from '@/pages/Pages/Templates/Templates.vue';

@Component({ components: { Templates } })
export default class WhatsappTemplates extends Vue {
  private transport: MsgTransports = MsgTransports.WHATSAPP;
}
